import { render, staticRenderFns } from "./DynamicItem.vue?vue&type=template&id=8294bc76&scoped=true&lang=html"
import script from "./DynamicItem.vue?vue&type=script&lang=js"
export * from "./DynamicItem.vue?vue&type=script&lang=js"
import style0 from "./DynamicItem.vue?vue&type=style&index=0&id=8294bc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8294bc76",
  null
  
)

export default component.exports